module.exports = __webpack_public_path__ + "img/bg.54271df7.png";